<div class="wrapper">

    <sl-input 
        class="wrapper__input" 
        type="number" 
        ngDefaultControl
        [name]="key"
        [label]="props.label | htmlDecode"
        [minlength]="props.minlength || null" 
        [maxlength]="props.maxlength || null" 
        [readonly]="props.readonly"
        [disabled]="props.disabled || false" 
        [required]="props.required || false" 
        [placeholder]="props.placeholder"
        [formControl]="formControl" 
        [formlyAttributes]="field" 
        [step]="stepValue" 
        [pattern]="pattern"
        [value]="props['defaultValue']">

        <ng-container *ngIf="props['currency']">
            <span slot="prefix">$</span>
        </ng-container>

        <ng-container *ngIf="props['priceField'] && !props['decimal'] && !props['currency']">
            <span slot="suffix">
                <span class="suffix-text">&times;</span>
                {{ props['multiplier'] || props['priceMultiplier'] | currency : '$' }}
            </span>
        </ng-container>
    </sl-input>
</div>